import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCourseGlyphSecondary from './svgs/CourseGlyphSecondary.js';
import SvgCourseGlyph from './svgs/CourseGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var courseGlyph = (props => useIcon(SvgCourseGlyph, SvgCourseGlyphSecondary, props));

export { courseGlyph as default };
